import React from 'react'
import Products from '../components/Products'

const Items = () => {
  return (
    <div className='container'>
      <div className='products'>
        <Products />
      </div>
    </div>
  )
}

export default Items
